import { MediaManagerBoardDto } from '../interfaces/supabase/media-manager/dto';
import { MediaManagerBoard } from '../interfaces/supabase/media-manager/entity';

const mediaManagerBoardDataMapper = (board: MediaManagerBoardDto): MediaManagerBoard => {
  const { created_at, updated_at, template_id, ...rest } = board;

  return {
    ...rest,
    createdAt: created_at,
    updatedAt: updated_at,
    templateId: template_id,
  };
};

export default mediaManagerBoardDataMapper;
